import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter-company_locations",
  "use": "icon-filter-company_locations-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-filter-company_locations\">\n  <path d=\"M8 14C8 14 12.5 10.4 12.5 6.6C12.5 4.18 10.49 2.3 8 2.3C5.51 2.3 3.5 4.18 3.5 6.6C3.5 10.4 8 14 8 14Z\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linejoin=\"round\" />\n  <circle cx=\"8\" cy=\"6.6\" r=\"1.7\" stroke=\"currentColor\" stroke-width=\"1.2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol